"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ErrorMessage = ({ message, statusCode }) => {
    if (statusCode === 0 || !message) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "coming-soon relative bg-df-gray-bg mt-6 p-6 px-5 rounded-2xl", children: (0, jsx_runtime_1.jsx)("p", { className: "mb-0", children: (0, jsx_runtime_1.jsx)("span", { children: message }) }) }));
};
exports.ErrorMessage = ErrorMessage;
